import { render, staticRenderFns } from "./CategoriaPecaEstudanteForm.vue?vue&type=template&id=68f2ba74"
import script from "./CategoriaPecaEstudanteForm.vue?vue&type=script&lang=js"
export * from "./CategoriaPecaEstudanteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports